import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SatelliteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"satellite"}/>
}
